export default __webpack_public_path__ + "static/media/careers-hero-mobile.969c8ee1.png";